import {
    SET_TICKETS,
    SET_TICKETS_CURRENT_PAGE,
    SET_TICKETS_TOTAL_PAGES,
    SET_TICKETS_TOTAL_DOCS,
    SET_SINGLE_TICKET,
    SET_TICKETS_STATUS
} from "../../@jumbo/constants/ActionTypes";

export const setTickets = (tickets) => {
    return (dispatch) => {
        dispatch({
            type: SET_TICKETS,
            payload: tickets,
        });
    };
};

export const setTicketsCurrentpage = (currentpage) => {
    return (dispatch) => {
        dispatch({
            type: SET_TICKETS_CURRENT_PAGE,
            payload: currentpage,
        });
    };
};

export const setTicketsTotalPages = (totalPages) => {
    return (dispatch) => {
        dispatch({
            type: SET_TICKETS_TOTAL_PAGES,
            payload: totalPages,
        });
    };
};

export const setTicketsTotalDocs = (totalDocs) => {
    return (dispatch) => {
        dispatch({
            type: SET_TICKETS_TOTAL_DOCS,
            payload: totalDocs,
        });
    };
};

export const setSingleTicket = (ticket) => {
    return (dispatch) => {
        dispatch({
            type: SET_SINGLE_TICKET,
            payload: ticket,
        });
    };
};

export const setTicketsStatus = (status) => {
    return (dispatch) => {
        dispatch({
            type: SET_TICKETS_STATUS,
            payload: status,
        });
    };
};